import { get, post, put, patch } from './_httpClient';

export async function getRegistrations({
  page,
  pageSize,
  batchId,
  divisionInstitutionsId,
  statusAcceptanceProgramId,
}) {
  const { status, message, data } = await get(
    `/clp/registrations?page=${page}&pageSize=${pageSize}&batchId=${batchId}&divisionInstitutionsId=${divisionInstitutionsId}&statusAcceptanceProgramId=${statusAcceptanceProgramId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getRegistrationsDetail({ id }) {
  return get(`/clp/registrations/${id}`);
}

export async function addRegistrations({ payload, ...others }) {
  return post('/clp/registrations', {
    ...payload,
    ...others,
  });
}

export async function getRegistrationsUsers() {
  return get('/clp/registrations/users');
}

export async function getRegistrationsJourney({ batchId }) {
  const { status, message, data } = await get(
    `/clp/metrics/registration-journey?batchId=${batchId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function patchRegistrationsJourney(step, batchId) {
  const query = batchId ? `?step=${step}&batchId=${batchId}` : `?step=${step}`;
  return patch(`/program/registrations-journey${query}`, {});
}

export async function getRegistrationsJourneyConfig({ batchId }) {
  const { status, message, data } = await get(
    `/program/registrations-journey/config?batchId=${batchId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function upsertRegistrationsJourneyConfig({ batchId, steps }) {
  const { status, message, data } = await put(
    '/program/registrations-journey/config',
    { batchId, steps },
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateRegistrationAcceptanceStatus({ payload, id }) {
  const responseJson = await put(
    `/clp/registrations/${id}/acceptance`,
    payload,
  );
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function getStatusAcceptance({ batchId }) {
  const { status, message, data } = await get(
    `/clp/registrations/status-acceptance?batchId=${batchId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getRegistrationsStatusAcceptanceOptions({ batchId }) {
  const { status, message, data } = await get(
    `/clp/registrations/status-acceptance/options?batchId=${batchId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getRegistrationsInstitutions({
  batchId,
  regenciesId,
  institutionTypeId,
}) {
  const { status, message, data } = await get(
    `/clp/registrations/institutions?batchId=${batchId}&regenciesId=${regenciesId}&institutionTypeId=${institutionTypeId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getRegistrationsInstitutionsDetail({
  divisionInstitutionsId,
  batchId,
}) {
  const { status, message, data } = await get(
    `/clp/registrations/institutions/${divisionInstitutionsId}?batchId=${batchId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getProgramOffered() {
  const { status, message, data } = await get(
    '/clp/registrations/offered-program',
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
